"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const libs_tracking_1 = require("@hotelplan/libs.tracking");
const TravelRooms_1 = __importDefault(require("./TravelRooms"));
function TravelRoomsMobileModal({ saveTravelRooms, isManualDistribution, configuration, show, travelRooms, close, }) {
    const [t] = (0, next_i18next_1.useTranslation)('search');
    return (react_1.default.createElement(components_common_modals_1.WhiteBoxModal, { name: "numberOfAdults", label: t('rooms.adultsNumber.label'), show: show, fullScreen: true, onClose: () => {
            (0, libs_tracking_1.trackTravelRooms)({
                type: libs_tracking_1.TravelRoomsEventType.TRAVEL_ROOMS_CANCEL,
            });
            close();
        } }, travelRooms && (react_1.default.createElement(TravelRooms_1.default, { saveTravelRooms: saveTravelRooms, value: travelRooms, isManualDistribution: isManualDistribution, configuration: configuration }))));
}
exports.default = TravelRoomsMobileModal;
//# sourceMappingURL=TravelRoomsMobileModal.js.map